import ApiCall from "./ApiCall";

const STORAGE_KEY = "affiliate_ref_code";

/**
 * Read the ?ref= code from the current URL, remember it, and record the click.
 *
 * The code is persisted so attribution survives the visitor browsing around
 * before they register. Called once on app boot.
 */
export const captureAffiliateRef = async () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("ref");

    if (!code) return;

    const trimmed = code.trim();
    if (!trimmed) return;

    const alreadyStored = localStorage.getItem(STORAGE_KEY);
    localStorage.setItem(STORAGE_KEY, trimmed);

    // Only count a click the first time we see this code, so a refresh or a
    // back-navigation doesn't inflate the affiliate's numbers.
    if (alreadyStored === trimmed) return;

    await ApiCall("POST", "affiliates/track-click", { code: trimmed });
  } catch (error) {
    // Tracking must never block the page from loading.
    console.error("Affiliate ref capture failed:", error);
  }
};

/**
 * The stored affiliate code, if the visitor arrived via a tracking link.
 */
export const getAffiliateRef = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
};

/**
 * Clear the stored code once it has been attributed to a signup.
 */
export const clearAffiliateRef = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
